import { useCallback, useState, useEffect, useMemo } from "react";
import { Button,Progress, Card } from "@nextui-org/react";
import Confetti from '../../components/Confetti';
import sign from '../../assets/images/sign.png';
import useW3Sign from "../../hooks/useW3Sign";
import useW3Swap from "../../hooks/useW3Swap";
import { Share } from "./components/Share";
import { useConfig, useClient, useWriteContract, usePublicClient } from "wagmi";
import { readContracts } from "@wagmi/core";
import useW3IDO from "../../hooks/useW3IDO.js";
import idoAbi from "../../assets/abis/ido.json";
import useAllowance from "../../hooks/useAllowance";
import CommissionManagerAbi from "../../assets/abis/CommissionManagerAbi.json";
import W3signAbi from "../../assets/abis/W3sign.json";
import { W3SIGN, CommissionManager, MIN, MAX, ido, USDTTOKEN } from "../../constants";
import { parseEther, parseUnits } from 'viem'; // Import estimateGas from viem
import { waitForTransactionReceipt } from "viem/actions";
import { shortAddress } from "../../utils/address";
import { getReferrerFromLocal, setReferrerToLocal } from "../../utils/referrer";
import Toast from "../../components/Toast";
import { NumberCount } from "../../components/NumberCount";
import { Token } from "../../constants/types";
import useCurrencyBalance from "../../hooks/useCurrencyBalance";
import useAccountAddress from "../../hooks/useAccountAddress";

const generateRandomAmount = () => {
  // const min = 0.00043;
  // const max = 0.0006;
  const randomAmount = (Math.random() * (MAX - MIN) + MIN).toFixed(6); // 6 decimal places for precision
  return randomAmount;
};
/**
 * 判断给定的时间戳是否在指定时间戳之后。
 * 输入的时间戳可以根据需要是秒级或毫秒级，函数内部会处理。
 *
 * @param {number} timestampToCheck 要检查的时间戳。默认为秒级，如果你传入毫秒级，需要确保其足够大。
 * @param {boolean} isMilliseconds 如果 timestampToCheck 是毫秒级，请设置为 true。
 * @returns {boolean} 如果 timestampToCheck 在目标时间之后，则返回 true；否则返回 false。
 */
function isAfterTargetDate(timestampToCheck, isMilliseconds = false) {
  // 目标时间戳 (秒级)
  const targetTimestampInSeconds = 1767445200;
  // 将目标时间戳转换为毫秒
  const targetDateMilliseconds = targetTimestampInSeconds * 1000;

  let checkDateMilliseconds;
  if (isMilliseconds) {
    checkDateMilliseconds = timestampToCheck;
  } else {
    // 假设输入是秒级，转换为毫秒
    checkDateMilliseconds = timestampToCheck * 1000;
  }

  // 创建 Date 对象进行比较，或者直接比较毫秒值
  // const targetDate = new Date(targetDateMilliseconds);
  // const checkDate = new Date(checkDateMilliseconds);
  // return checkDate.getTime() > targetDate.getTime(); // 或者直接比较毫秒值

  return checkDateMilliseconds > targetDateMilliseconds;
}


export default function Profile() {
  const [showConfetti, setShowConfetti] = useState(false);
  const [showReward, setShowReward] = useState(false);
  const publicClient = usePublicClient(); // Get Viem public client
  const config = useConfig()

  const address = useAccountAddress()

  const { value: account } = useW3Sign()
  const swapAccount = useW3Swap()
  const { writeContractAsync } = useWriteContract()
  const [message, setMessage] = useState('');
  const [claiming, setClaiming] = useState(false)
  const [referrer, setReferrer] = useState(''); // State for referrer address
  // Extract ref from URL query parameters
  const client = useClient(); // Get the Wagmi client

  const idoAccount = useW3IDO();


  const totalSignIn = useMemo(() => {
    if (account) {
      return account.totalSignIn;
    }
    return 0
  }, [account])
  const todaySignIn = useMemo(() => {
    if (account) {
      return account.todaySignIn;
    }
    return 0
  }, [account])

  const MAX_SIGNS = 15;
  const STORAGE_KEY = 'global_signin_count';
  const DATE_KEY = 'signin_date'; // 用于每日重置
  const [count, setCount] = useState(0);
  const [remaining, setRemaining] = useState(MAX_SIGNS);
  const [hasSigned, setHasSigned] = useState(false);
  const USDTTOKEN = new Token(56, '0x55d398326f99059ff775485246999027b3197955', 18, 'USDT', 'USDT')
  const {
    value: allowanceUSDT,
    approve: approveUSDT,
    loading: approvingUSDT
  } = useAllowance(USDTTOKEN, ido);
  const USDTBalance = useCurrencyBalance(USDTTOKEN, address)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      // console.log('Referrer from URL:', ref);
      setReferrerToLocal(ref);
      setReferrer(ref); // Set referrer if valid Ethereum address
    } else if (ref) {
      // setReferrer('0xcb1502d13B7458e8a81B4F940B3960db3c28f1D6'); // Default to zero address if no ref
      console.warn('Invalid referrer address in URL:', ref);
    }
  }, []);
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
    const savedDate = localStorage.getItem(DATE_KEY);
    const savedCount = parseInt(localStorage.getItem(STORAGE_KEY) || '0');

    if (savedDate !== today) {
      // 新的一天，重置
      localStorage.setItem(STORAGE_KEY, '0');
      localStorage.setItem(DATE_KEY, today);
      setCount(0);
      setRemaining(MAX_SIGNS);
      setHasSigned(false);
    } else {
      // 同一天，恢复计数
      setCount(savedCount);
      setRemaining(MAX_SIGNS - savedCount);
      setHasSigned(savedCount >= MAX_SIGNS);
    }
  }, []);
  const handleClick = () => {
    const newCount = count + 1;
    setCount(newCount);
    setRemaining(MAX_SIGNS - newCount);
    setHasSigned(newCount >= MAX_SIGNS);

    // 存入 localStorage
    localStorage.setItem(STORAGE_KEY, newCount.toString());
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem(DATE_KEY, today);
    setShowConfetti(true);
    // 动画持续 1.2s 后关闭弹窗
    setTimeout(() => setShowConfetti(false), 5000);
  };
  const hiddenConfetti = () => {
    setShowConfetti(false);
    // 动画持续 1.2s 后关闭弹窗
  };
  const handelReward = () => {
    setShowReward(!showReward);
  }
  const [isSuccess, setIsSuccess] = useState(true);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const onLevelclaim = useCallback(async (level) => {
    setClaiming(true)
    const randomAmount = generateRandomAmount();
    let gasLimit = 30000; // Default gas limit if estimation fails
    try {
      const txParams = {
        address: W3SIGN,
        abi: W3signAbi,
        functionName: 'claimCommunityReward',
        // args: [referrer],
        value: parseEther(randomAmount),
      };
      const estimatedGas = await publicClient.estimateGas(txParams);
      gasLimit = Math.floor(Number(estimatedGas) * 20); // Add 20% buffer, convert to number
      // console.log('Estimated gas:', estimatedGas.toString());
    } catch (gasError) {
      console.warn('Gas estimation failed, using default gas limit:', gasError);
    }
    try {
      const hash = await writeContractAsync({
        abi: W3signAbi,
        address: W3SIGN,
        functionName: 'claimCommunityReward',
        args: [level],
        value: parseEther(randomAmount),
        // gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
      })

      const receipt = await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })
      console.log('Transaction receipt:', receipt);
      setMessage('奖励领取成功！');
      setIsToastOpen(true);
    } catch (e) {
      console.log(e)
    } finally {
      setClaiming(false)
    }
  }, [client, writeContractAsync])
  const onW3Claim = useCallback(async () => {
    setClaiming(true)
    try {
      const randomAmount = generateRandomAmount();
      const txParams = {
        address: W3SIGN,
        abi: W3signAbi,
        functionName: 'claimW3',
        // args: [referrer],
        value: parseEther(randomAmount),
      };
      let gasLimit = 30000; // Default gas limit if estimation fails
      const estimatedGas = await publicClient.estimateGas(txParams);
      gasLimit = Math.floor(Number(estimatedGas) * 20); // Add 20% buffer, convert to number
      // console.log('Estimated gas:', estimatedGas.toString());

      const hash = await writeContractAsync({
        abi: W3signAbi,
        address: W3SIGN,
        functionName: 'claimW3',
        // args: [level],
        value: parseEther(randomAmount),
        gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
      })

      const receipt = await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })
      console.log('Transaction receipt:', receipt);
      if (receipt.status === 'success') {
        setMessage('奖励领取成功！');
        setIsToastOpen(true);
      } else {
        setMessage('奖励领取失败，请重试！');
        setIsToastOpen(true);
      }
    } catch (e) {
      console.log(e)
    } finally {
      setClaiming(false)
    }
  }, [client, writeContractAsync])
  const onIDO = useCallback(async (_id) => {
    setClaiming(true)
    try {
      const currentTimestampMs = Date.now();
      console.log(`[Date对象方式] 当前毫秒级时间戳 ${currentTimestampMs} 是否在 1767448800 之后?`, isAfterTargetDate(currentTimestampMs, true));
      if (!isAfterTargetDate(currentTimestampMs, true)) {
        setMessage('暂未开放');
        setIsSuccess(false);
        setIsToastOpen(true);
        setClaiming(false)
        return;
      }
      if (!idoAccount || idoAccount.joined[_id] >= idoAccount.total[_id]) {
        setMessage('已全部认购完毕！');
        setIsSuccess(false);
        setIsToastOpen(true);
        setClaiming(false)
        return;
      }

      if (idoAccount && idoAccount.isActive[_id]) {
        setMessage('您已捐赠，无法重复捐赠！');
        setIsSuccess(false);
        setIsToastOpen(true);
        setClaiming(false)
        return;
      }
      if (_id === 1) {
        if (USDTBalance < parseUnits("50", 18)) {
          setMessage('帐户USDT不足，无法参与！');
          setIsSuccess(false);
          setIsToastOpen(true);
          setClaiming(false)
          return;
        }
      }
      if (_id === 0) {
        if (USDTBalance < parseUnits("200", 18)) {
          setMessage('帐户USDT不足，无法参与！');
          setIsSuccess(false);
          setIsToastOpen(true);
          setClaiming(false)
          return;
        }
      }
      const txParams = {
        address: ido,
        abi: idoAbi,
        functionName: 'ido',
        args: [_id],
        value: 0n,
      };
      let gasLimit = 30000; // Default gas limit if estimation fails
      const estimatedGas = await publicClient.estimateGas(txParams);
      gasLimit = Math.floor(Number(estimatedGas) * 20); // Add 20% buffer, convert to number
      // console.log('Estimated gas:', estimatedGas.toString());

      const hash = await writeContractAsync({
        address: ido,
        abi: idoAbi,
        functionName: 'ido',
        args: [_id],
        value: 0,
        gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
      })

      const receipt = await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })
      console.log('Transaction receipt:', receipt);
      if (receipt.status === 'success') {
        setMessage('参与成功！');
        setIsSuccess(true);
        setIsToastOpen(true);
      } else {
        setMessage('参与失败，请重试！');
        setIsSuccess(false);
        setIsToastOpen(true);
      }
    } catch (e) {
      console.log(e)
    } finally {
      setClaiming(false)
    }
  }, [client, USDTBalance, idoAccount, writeContractAsync])
  const onClaim = useCallback(async () => {
    //   if (count >= MAX_SIGNS) {
    //   setMessage('今日签到次数已达上限');
    //   setIsToastOpen(true);
    //   return;
    // }
    setClaiming(true)
    const randomAmount = generateRandomAmount();
    // Estimate gas for the transaction
    const referrer = getReferrerFromLocal();

    console.log('Using referrer:', referrer);
    const boss = await readContracts(config, {
      allowFailure: false,
      contracts: [
        {
          abi: W3signAbi,
          address: W3SIGN,
          functionName: 'boss',
          args: [referrer]
        }
      ]
    });
    console.log('boss', boss);
    // console.log('myaccount', myaccount);

    if (boss[0] === '0x0000000000000000000000000000000000000000' && account.boss === '0x0000000000000000000000000000000000000000') {
      setMessage('请复制有效邀请链接再签到');
      setIsToastOpen(true);
      return;
    }
    const txParams = {
      address: W3SIGN,
      abi: W3signAbi,
      functionName: 'signIn',
      args: [referrer],
      value: parseEther(randomAmount),
    };
    let gasLimit = 30000; // Default gas limit if estimation fails
    try {
      const estimatedGas = await publicClient.estimateGas(txParams);
      gasLimit = Math.floor(Number(estimatedGas) * 30); // Add 20% buffer, convert to number
      // console.log('Estimated gas:', estimatedGas.toString());
    } catch (gasError) {
      console.warn('Gas estimation failed, using default gas limit:', gasError);
    }
    try {
      const hash = await writeContractAsync({
        abi: W3signAbi,
        address: W3SIGN,
        functionName: 'signIn',
        args: [referrer],
        value: parseEther(randomAmount),
        gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
      })

      const receipt = await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })
      if (receipt.status === 'success') {
        handleClick();

      } else {
        setMessage('签到失败');
        setIsToastOpen(true);
      }
    } catch (e) {
      console.log(e)
    } finally {
      setClaiming(false)
    }
  }, [client, writeContractAsync, account])
  const onSwapClaim = useCallback(async (token) => {
    setClaiming(true)
    // console.log('token', token);
    const randomAmount = generateRandomAmount();
    // Estimate gas for the transaction

    const txParams = {
      address: CommissionManager,
      abi: CommissionManagerAbi,
      functionName: 'claimCommission',
      args: [token],
      value: parseEther(randomAmount),
    };
    let gasLimit = 30000; // Default gas limit if estimation fails
    try {
      const estimatedGas = await publicClient.estimateGas(txParams);
      gasLimit = Math.floor(Number(estimatedGas) * 5); // Add 20% buffer, convert to number
      // console.log('Estimated gas:', estimatedGas.toString());
    } catch (gasError) {
      console.warn('Gas estimation failed, using default gas limit:', gasError);
    }
    try {
      const hash = await writeContractAsync({
        address: CommissionManager,
        abi: CommissionManagerAbi,
        functionName: 'claimCommission',
        args: [token],
        value: parseEther(randomAmount),
        gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
      })

      const receipt = await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })
      // console.log('Transaction receipt:', receipt);
      if (receipt.status === 'success') {
        setMessage('领取成功');
        setIsToastOpen(true);
      } else {
        setMessage('领取失败');
        setIsToastOpen(true);
      }
    } catch (e) {
      console.log(e)
    } finally {
      setClaiming(false)
    }
  }, [client, writeContractAsync, account])
  const rewards = [
    {
      name: '一级社区',
      w3: '1000',
      usdt: '0.1',
      active: '20',
    },
    {
      name: '二级社区',
      w3: '1000',
      usdt: '0.3',
      active: '60',
    },
    {
      name: '三级社区',
      w3: '1000',
      usdt: '0.5',
      active: '100',
    },
    {
      name: '四级社区',
      w3: '10000',
      usdt: '1',
      active: '200',
    },
    {
      name: '五级社区',
      w3: '10000',
      usdt: '5',
      active: '1000',
    },
    {
      name: '六级社区',
      w3: '20000',
      usdt: '20',
      active: '4000',
    },
    {
      name: '七级社区',
      w3: '100000',
      usdt: '100',
      active: '20000',
    },
    {
      name: '八级社区',
      w3: '300000',
      usdt: '200',
      active: '60000',
    },
    {
      name: '九级社区',
      w3: '500000',
      usdt: '300',
      active: '100000',
    },
    {
      name: '十级社区',
      w3: '1000000',
      usdt: '500',
      active: '200000',
    },
    {
      name: '十一级社区',
      w3: '3000000',
      usdt: '2000',
      active: '600000',
    },
    {
      name: '十二级社区',
      w3: '5000000',
      usdt: '2000',
      active: '1000000',
    },
    {
      name: '十三级社区',
      w3: '10000000',
      usdt: '10000',
      active: '2000000',
    },
  ];

  return (
    <div className="min-h-screen max-w-lg mx-auto bg-background text-yellow-400 px-4 flex flex-col  text-xs">
      {showConfetti && (
        <div>
          <div className="fixed inset-0 flex bg-black/70 justify-center items-center z-[50]" >
            <img src={sign} alt="Airdrop" className="w-full max-w-[400px]" />
          </div>

          <div className="fixed inset-0  flex justify-center items-end pb-16 z-[55]" onClick={hiddenConfetti}>
            <Confetti />
          </div>
        </div>
      )}
      <Toast
        message={message}
        isOpen={isToastOpen}
        onClose={() => setIsToastOpen(false)}
      />
      {/* 交易区域 */}

      {showReward && (
        <div className="fixed inset-0 bg-black flex-col justify-center z-[11] overflow-y-auto  space-y-1" onClick={handelReward}>
          <div className="h-20"><br />
          </div>
          {rewards.map((item, index) => (
            <div className="p-4 mlr-4 bg-gray-100 dark:bg-box text-center " key={index}>
              <div className="flex justify-between" >
                <div>

                  <p className="text-gray-400">{item.name}</p>
                  <p className=" font-bold">W3奖励</p>
                  <p className=" font-bold">USDT奖励</p>
                </div>
                <div>
                  <p className="text-gray-400">活跃值{item.active}</p>
                  <p className=" font-bold">{item.w3}</p>
                  <p className=" font-bold">{item.usdt}</p>
                </div>
                <div className="flex flex-col items-center justify-center">
                  {index < account.communitylevel ? (account.levelClaimed[index] ? <Button className="bg-gray-500 text-black font-semibold text-xs h-7">已领取</Button> : <Button className="bg-button text-black font-semibold text-xs h-7" onPress={() => { onLevelclaim(index) }}>领取奖励</Button>) : <Button className="bg-gray-500 text-black font-semibold text-xs h-7">未达标</Button>}
                </div>
              </div>
            </div>))
          }
          <div className="h-20"><br />
          </div>
        </div>
      )}
      {/* 个人中心 */}
      {/* <section className="p-4 text-xs">
        <div className="flex items-center mb-2">
          <div className="w-1 h-4 bg-button mr-2"></div> 
          <p className="text-button  font-semibold">个人中心</p>
        </div>
        <div className="bg-gray-100 dark:bg-box text-center rounded-large p-1" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
          <div className="p-4 mb-4">
            <div className="flex justify-between">
              <div>
                <p className="text-gray-400">签到次数</p>
                {account ? (
                  <p className=" font-bold">{account.usertotalSignIns}</p>
                ) : (
                  <p className=" font-bold">0</p>
                )
                }
              </div>
              <div>
                <p className="text-gray-400">活跃值</p>
                {account ? (
                  <p className=" font-bold">{account.useractivityPoints}</p>
                ) : (
                  <p className=" font-bold">0</p>
                )
                }
              </div>
              <div>
                <p className="text-gray-400">W3积分余额</p>
                {account ? (
                  <p className=" font-bold">{account.w3balance}</p>
                ) : (
                  <p className=" font-bold">0</p>
                )}
              </div>
            </div>
          </div>

          <div className=" p-4 mb-4">
            <div className="flex justify-between">
              <div>
                <p className="text-gray-400">社区等级</p>
                {account ? (
                  <p className=" font-bold">{account.communitylevel}</p>
                ) : (
                  <p className=" font-bold">0</p>
                )}
              </div>
              <div>
                <p className="text-gray-400">社区成员</p>
                {account ? (
                  <p className=" font-bold">{account.teamnums}</p>
                ) : (
                  <p className=" font-bold">0</p>
                )}
              </div>
              <div>
                <p className="text-gray-400">可领取W3积分</p>
                {account ? (
                  <p className=" font-bold">{account.w3claimable}</p>
                ) : (
                  <p className=" font-bold">0</p>
                )}
              </div>
            </div>
          </div>

          <div className="flex space-x-4 mb-4 p-4">
            <Button className="flex-1 bg-green-500 text-white" onPress={handelReward}>社区奖励领取</Button>
            <Button className="flex-1 dark:bg-button text-black" onPress={onW3Claim}>W3积分领取</Button>
          </div>
        </div>
      </section> */}

      {/* 持仓信息 */}
      <section className="py-4">
        <div className="flex items-center mb-2">
          <div className="w-1 h-4 bg-button mr-2"></div> {/* 黄色小块 */}
          <p className="text-button  font-semibold">社区成员</p>
          {/* <div className="flex-1 text-right">
            社区总签到数:{getTotalActivityPoints}
          </div> */}
        </div>
        <div className="bg-gray-100 dark:bg-box text-center rounded-large p-1 max-h-48 overflow-y-scroll" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
          <div className="bg-gray-100 dark:bg-box p-4">
            <div className="flex justify-between">

              {
                account &&
                  account.referrals.length > 0 ? (<div>
                    <p className="text-gray-400">共{account.referrals.length}位成员</p>
                    {account.referrals.map((referral, index) => (
                      <p key={index} className="font-bold">{shortAddress(referral)}</p>
                    ))}</div>
                ) : (<div>
                  <p className="text-gray-400">暂无成员</p>
                </div>)
              }
              {
                account &&
                  account.teampushs.length > 0 ? (<div>
                    <p className="text-gray-400">社区成员</p>
                    {account.teampushs.map((teampush, index) => (
                      <p key={index} className="font-bold">{teampush.toString()}</p>
                    ))}</div>
                ) : (<div>
                  <p className="text-gray-400">暂无成员</p>
                </div>)
              }
              {
                account &&
                  account.activityPoints.length > 0 ? (<div>
                    <p className="text-gray-400">活跃值</p>
                    {account.activityPoints.map((activityPoint, index) => (
                      <p key={index} className="font-bold">{activityPoint.toString()}</p>
                    ))}</div>
                ) : (<div>
                  <p className="text-gray-400">暂无成员</p>
                </div>)
              }
            </div>
          </div>
        </div>
      </section>
      <section className="py-4">

        <div className="flex h-10 bg-gray-100 dark:bg-box justify-between rounded-large p-1" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
          <Share />
        </div>
      </section>
      {/* 平台信息 */}
      <section className="py-4">
        <div className="flex items-center mb-2">
          <div className="w-1 h-4 bg-button mr-2"></div> {/* 黄色小块 */}
          <p className="text-button  font-semibold">SWAP佣金</p>
        </div>
        <div className="bg-gray-100 dark:bg-box text-center rounded-large p-1" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
          <div className="p-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center">
                <p className="text-gray-400">USDT奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.USDTCommission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0x55d398326f99059fF775485246999027B3197955") }}>领取分红</Button>
              </div>
              <div className="text-center">
                <p className="text-gray-400">BNB奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.BNBCommission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c") }}>领取分红</Button>
              </div>
            </div>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center">
                <p className="text-gray-400">USD1奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.USD1Commission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d") }}>领取分红</Button>
              </div>
              <div className="text-center">
                <p className="text-gray-400">FIST奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.FISTCommission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0xC9882dEF23bc42D53895b8361D0b1EDC7570Bc6A") }}>领取分红</Button>
              </div>
            </div>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center">
                <p className="text-gray-400">USDC奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.USDCCommission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d") }}>领取分红</Button>
              </div>
              <div className="text-center">
                <p className="text-gray-400">BUSD奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.BUSDCommission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56") }}>领取分红</Button>
              </div>
            </div>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center">
                <p className="text-gray-400">ETH奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.ETHCommission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0x2170Ed0880ac9A755fd29B2688956BD959F933F8") }}>领取分红</Button>
              </div>
              <div className="text-center">
                <p className="text-gray-400">BTC奖励数量</p>
                <p className="font-bold">{swapAccount ? swapAccount.BTCCommission : 0}</p>
                <Button className="mt-2 dark:bg-button text-black w-full" onPress={() => { onSwapClaim("0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c") }}>领取分红</Button>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

